export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const EMAIL = 'a.fedosov@andersenlab.com';

export const MEETUP_DATE = '2026-01-21';
export const MEETUP_TIME = '5:30 PM (GMT)';
